// @ts-nocheck

export const ODDS_TRAVEL_ANIMATION_DURATION = 1000;
